import React, { useState, useEffect } from 'react'
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Grid, TextField, Stack, Input, Button, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Card, IconButton, Typography, Box } from '@mui/material';
import MDBox from "components/MDBox";
import DataTable from "examples/Tables/DataTable";
import Papa from "papaparse";
import DescriptionIcon from "@mui/icons-material/Description";
import Tooltip from "@mui/material/Tooltip";
import '../campus/Campus.css'

const BASE_URL = process.env.REACT_APP_BASE_URL;
const token = sessionStorage.getItem("token");

const UploadAffiliateCollege = () => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [all_campaigns, setAllCampaigns] = useState([]);
    const [all_departments, setAllDepartments] = useState([]);
    const [all_degrees, setAllDegrees] = useState([]);
    const [campaign_id, setCampaignId] = useState("");
    const [department_id, setDepartmentId] = useState("");
    const [degree_id, setDegreeId] = useState("");
    const [csvData, setCsvData] = useState([]);
    const [base64Data, setBase64Data] = useState("");
    const [selectedRow, setSelectedRow] = useState(null);
    const [showDeleteCampaignModal, setShowDeleteCampaignModal] = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [csvHeaders, setCsvHeaders] = useState([]);
    const [academicData, setAcademicData] = useState([]);
    const [all_quotas, setAllQuotas] = useState([]);
    const [academicFile, setAcademicFile] = useState(null);
    const [quota_id, setQuotaId] = useState([]);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);
    const [submitError, setSubmitError] = useState(null);

    const getAllCampaigns = async () => {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        await fetch(BASE_URL + `/campaign/get_campaigns`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setAllCampaigns(data.campaigns);
            })
            .catch((error) => console.log(error));
    };

    const getDepartments = async () => {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        await fetch(BASE_URL + `/department/get_departments`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setAllDepartments(data.departments);
            })
            .catch((error) => console.log(error));
    };

    const getDegreesByDepartments = async (department_id) => {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        await fetch(
            BASE_URL + `/degree/get_degrees_by_department/${department_id}`,
            requestOptions
        )
            .then((response) => response.json())
            .then((data) => {
                setAllDegrees(data.degrees);
            })
            .catch((error) => console.log(error));
    };

    const getQuotas = async () => {
        const requestOptions = {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
        };
        await fetch(BASE_URL + `/quota/get_quotas`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                setAllQuotas(data.quotas);
            })
            .catch((error) => console.log(error));
    };

    const handleDepartment = (value) => {
        setDepartmentId(value);
        getDegreesByDepartments(value);
    };

    const handleDegree = (value) => {
        setDegreeId(value);
        getQuotas();
    };

    const handleCampaign = (value) => {
        setCampaignId(value);
    };

    const handleQuota = (value) => {
        setQuotaId(value);
    };

    useEffect(() => {
        getAllCampaigns();
        getDepartments();
    }, []);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setSelectedFile(file);

        Papa.parse(file, {
            header: true,
            complete: (result) => {
                setCsvData(result.data);
            },
            error: (error) => {
                console.error("Error parsing CSV:", error);
                setSubmitError("Error parsing CSV file. Please check the file format.");
            }
        });
    };

    const handleAcademicFileChange = (e) => {
        const file = e.target.files[0];
        setAcademicFile(file);

        Papa.parse(file, {
            complete: (result) => {
                setAcademicData(result.data);
            },
            header: true,
        });
    };

    const handleSubmitAll = async () => {
        if (!campaign_id || !degree_id || !quota_id) {
            setSubmitError("Please select Campaign, Program, and Quota before submitting.");
            return;
        }

        if (csvData.length === 0) {
            setSubmitError("Please upload applications data before submitting.");
            return;
        }

        setIsSubmitting(true);
        setSubmitError(null);

        try {
            const applications = csvData.map((data) => ({
                campaign_id: Number(campaign_id),
                program_id: Number(degree_id),
                quota_id: Number(quota_id),
                cnic: data.cnic,
                dob: data.dob,
                name: data.name,
                father_name: data.father_name,
                father_occupation: data.father_occupation,
                father_income: data.father_income,
                father_cnic: data.father_cnic,
                gender: data.gender,
                nationality: data.nationality,
                province: data.province,
                domicile: data.domicile,
                religion: data.religion,
                current_address: data.current_address,
                permanent_address: data.permanent_address,
                tel_no: data.tel_no,
                father_cell_no: data.father_cell_no,
                applicant_cell_no: data.applicant_cell_no,
                hafiz_quran: data.hafiz_quran,
                disability: data.disability,
                applicant_image: data.applicant_image || "",
                applicant_cnic_front: data.applicant_cnic_front || "",
                applicant_cnic_back: data.applicant_cnic_back || "",
                father_cnic_front: data.father_cnic_front || "",
                father_cnic_back: data.father_cnic_back || "",
                emergency_contact_name: data.emergency_contact_name || "",
                emergency_contact_cell_no: data.emergency_contact_cell_no || "",
                emergency_contact_address: data.emergency_contact_address || "",
                academics: academicData.filter(academic => academic.cnic === data.cnic)
            }));

            const response = await fetch(`${BASE_URL}/submit_application/upload_affiliate_applicant`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ applications }),
            });

            const result = await response.json();
            
            if (response.ok) {
                setSubmitSuccess(true);
                // Clear the form
                setCsvData([]);
                setSelectedFile(null);
                setAcademicFile(null);
                setAcademicData([]);
                setCampaignId([]);
                setDepartmentId([]);
                setDegreeId([]);
                setQuotaId([]);
                setTimeout(() => setSubmitSuccess(false), 5000); // Clear success message after 5 seconds
            } else {
                throw new Error(result.message || 'Failed to submit applications');
            }
        } catch (error) {
            setSubmitError(error.message);
        } finally {
            setIsSubmitting(false);
        }
    };

    const columns = [
        { Header: "Sr.No", accessor: "serial", align: "center" },
        { Header: "Name", accessor: "name", align: "center" },
        { Header: "Gender", accessor: "gender", align: "center" },
        { Header: "CNIC", accessor: "cnic", align: "center" },
        { Header: "DOB", accessor: "dob", align: "center" },
        { Header: "Applicant Cell", accessor: "applicant_cell_no", align: "center" },
        { Header: "Province", accessor: "province", align: "center" },
        { Header: "Guardian Name", accessor: "father_name", align: "center" },
        { Header: "Guardian Cell", accessor: "father_cell_no", align: "center" },
        {
            Header: "Actions",
            accessor: "actions",
            align: "center",
            Cell: ({ row }) => (
                <Tooltip title="Academic Records" arrow>
                    <IconButton
                        aria-label="edit"
                        onClick={() => {
                            setSelectedRow(row.original);
                            setModalOpen(true);
                        }}
                    >
                        <DescriptionIcon className="icon-button-edit" />
                    </IconButton>
                </Tooltip>
            ),
        },
    ];

    const rows = csvData.length > 0
        ? csvData.map((data, index) => ({
            serial: index + 1,
            name: data["name"] || "",
            gender: data["gender"] || "",
            cnic: data["cnic"] || "",
            dob: data["date_of_birth"] || "",
            applicant_cell_no: data["applicant_cell_no"] || "",
            province: data["province"] || "",
            father_name: data["father_name"] || "",
            father_cell_no: data["father_cell_no"] || "",
        }))
        : [];

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div style={{ padding: '20px' }}>
                {/* Submit All Applications Button */}
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 3 }}>
                    <Button
                        variant="contained"
                        onClick={handleSubmitAll}
                        disabled={isSubmitting || csvData.length === 0}
                        sx={{
                            backgroundColor: '#28166f',
                            color: '#fff',
                            '&:hover': {
                                backgroundColor: '#1557b0',
                            },
                            '&:disabled': {
                                backgroundColor: '#ccc',
                            },
                        }}
                    >
                        {isSubmitting ? 'Submitting...' : 'Submit All Applications'}
                    </Button>
                </Box>

                {/* Success Message */}
                {submitSuccess && (
                    <Box sx={{ mb: 2, p: 2, backgroundColor: '#e8f5e9', borderRadius: 1 }}>
                        <Typography color="success">
                            Applications submitted successfully!
                        </Typography>
                    </Box>
                )}

                {/* Error Message */}
                {submitError && (
                    <Box sx={{ mb: 2, p: 2, backgroundColor: '#ffebee', borderRadius: 1 }}>
                        <Typography color="error">
                            {submitError}
                        </Typography>
                    </Box>
                )}

                <Grid container spacing={3}>
                    <Grid item xs={12} md={6}>
                        <Box className="instructions">
                            <Typography variant="body1" color="#f44336" gutterBottom>
                                Please follow the instructions below to ensure proper uploading of the affiliate list.
                            </Typography>
                            <Typography variant="body1" className='points'>
                                1. Provide all information about the affiliate and make sure to review your List carefully before upload.
                            </Typography>
                            <Typography variant="body1" className='points'>
                                2. Ensure that all the necessary data is provided.
                            </Typography>
                            <Typography variant="body1" className='points'>
                                3. Instead of uploading images, please share a link to the images related to the affiliate.
                            </Typography>
                            <Typography variant="body1" className='points'>
                                4. The file should only include required columns of data. See the sample file: {" "}
                                <a href="sample_affiliate_list.csv" download>
                                    Affiliate List Template
                                </a>
                            </Typography>
                        </Box>
                    </Grid>

                    <Grid item xs={12} md={6} display="flex" justifyContent="center" alignItems="center">
                        <Box sx={{ textAlign: "center", padding: 2, border: "1px solid #ccc", borderRadius: 2, width: "100%", }}>
                            <Typography variant="body1" mb={1}>
                                Upload your affiliate list here:
                            </Typography>
                            <Input 
                                type="file" 
                                onChange={handleFileChange} 
                                className="form-control form-control-md"
                                disabled={isSubmitting}
                            />
                        </Box>
                    </Grid>
                </Grid>

                <Typography variant="body1" fontSize='22px' gutterBottom sx={{ mt: 4 }}>
                    Program Selection
                </Typography>
                <Stack
                    direction="row"
                    justifyContent="flex-start"
                    alignItems="center"
                    spacing={1}
                    paddingRight={3}
                >
                    <div className="col-md-3">
                        <label htmlFor="filter_campaign_id">Campaign</label>
                        <select
                            id="filter_campaign_id"
                            className="form-control form-control-md2"
                            value={campaign_id}
                            onChange={(e) => handleCampaign(e.target.value)}
                            disabled={isSubmitting}
                        >
                            <option value="">Select Campaign</option>
                            {all_campaigns.map((camp) => (
                                <option key={camp.id} value={camp.id}>
                                    {camp.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="filter_department_id">Department</label>
                        <select
                            id="filter_department_id"
                            className="form-control form-control-md2"
                            value={department_id}
                            onChange={(e) => handleDepartment(e.target.value)}
                            disabled={isSubmitting}
                        >
                            <option value="">Select Department</option>
                            {all_departments.map((dept) => (
                                <option key={dept.id} value={dept.id}>
                                    {dept.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="filter_degree_id">Programs</label>
                        <select
                            id="filter_degree_id"
                            className="form-control form-control-md2"
                            value={degree_id}
                            onChange={(e) => handleDegree(e.target.value)}
                            disabled={isSubmitting}
                        >
                            <option value="">Select Program</option>
                            {all_degrees.map((degree) => (
                                <option key={degree.id} value={degree.id}>
                                    {degree.name}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-3">
                        <label htmlFor="filter_quota_id">Quotas</label>
                        <select
                            id="filter_quota_id"
                            className="form-control form-control-md2"
                            value={quota_id}
                            onChange={(e) => handleQuota(e.target.value)}
                            disabled={isSubmitting}
                        >
                            <option value="">Select Quota</option>
                            {all_quotas.map((quota) => (
                                <option key={quota.id} value={quota.id}>
                                    {quota.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </Stack>

                <Card className="mt-5 card1">
                    <MDBox pt={3}>
                        {csvData && csvData.length > 0 ? (
                            <DataTable
                                table={{ columns, rows }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                            />
                        ) : (
                            <div style={{ textAlign: "center", padding: "2rem" }}>
                                <img
                                    src="nodata.png"
                                    alt="No data available"
                                    style={{
                                        display: "block",
                                        margin: "auto",
                                        width: "20%",
                                        height: "20%",
                                    }}
                                />
                                <Typography variant="body1" color="textSecondary" sx={{ mt: 2 }}>
                                    No applications uploaded yet
                                </Typography>
                            </div>
                        )}
                    </MDBox>
                </Card>

                {/* Academic Records Modal */}
                <Dialog
                    open={modalOpen}
                    onClose={() => setModalOpen(false)}
                    aria-labelledby="academic-test-report-title"
                    PaperProps={{
                        sx: {
                            width: "90%",
                            maxWidth: 500,
                            borderRadius: 3,
                            padding: 3,
                            backgroundColor: "#f9f9f9",
                        },
                    }}
                >
                    <DialogTitle
                        id="academic-test-report-title"
                        sx={{
                            fontSize: 20,
                            fontWeight: "bold",
                            color: "#333",
                            textAlign: "center",
                            pb: 1,
                        }}
                    >
                        Academic Records for {selectedRow?.name}
                    </DialogTitle>

                    <DialogContent>
                        <Typography variant="body2" sx={{ mt: 1, mb: 2, color: "#f44336", fontWeight: "bold", textAlign: "center" }}>
                            Note: The file should only contain predefined academic record types. Ensure that you select from the allowed categories.
                        </Typography>

                        <Typography variant="body2" sx={{ mt: 2, mb: 2, textAlign: "center" }}>
                            <strong>Download the sample template:</strong>{" "}
                            <a href="sample_academic_template.csv" download style={{ color: "#007bff", textDecoration: "none" }}>
                                Sample Academic Template
                            </a>
                        </Typography>

                        {/* Academic File Upload Input */}
                        <Input
                            type="file"
                            onChange={handleAcademicFileChange}
                            inputProps={{ accept: ".csv" }}
                            sx={{
                                display: "block",
                                margin: "auto",
                                padding: 1,
                                border: "1px solid #ddd",
                                borderRadius: 2,
                                backgroundColor: "#fff",
                                width: "100%",
                            }}
                            disabled={isSubmitting}
                        />

                        {/* Display uploaded academic records if any */}
                        {academicData.length > 0 && selectedRow && (
                            <Box sx={{ mt: 3 }}>
                                <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: "bold" }}>
                                    Uploaded Academic Records:
                                </Typography>
                                <Box sx={{ maxHeight: "200px", overflowY: "auto" }}>
                                    {academicData.map((record, index) => (
                                            <Box
                                                key={index}
                                                sx={{
                                                    p: 1,
                                                    mb: 1,
                                                    backgroundColor: "#fff",
                                                    borderRadius: 1,
                                                    border: "1px solid #eee"
                                                }}
                                            >
                                                <Typography variant="body2">
                                                    Degree: {record.degree}
                                                </Typography>
                                                <Typography variant="body2">
                                                    Board: {record.board}
                                                </Typography>
                                                <Typography variant="body2">
                                                    Year: {record.year}
                                                </Typography>
                                            </Box>
                                        ))}
                                </Box>
                            </Box>
                        )}
                    </DialogContent>

                    <DialogActions>
                        <Button 
                            onClick={() => setModalOpen(false)} 
                            className="dialog-actions-button negative"
                            disabled={isSubmitting}
                        >
                            Cancel
                        </Button>
                        <Button 
                            onClick={() => {
                                setModalOpen(false);
                                setSubmitSuccess(false);
                                setSubmitError(null);
                            }} 
                            className="dialog-actions-button positive"
                            disabled={isSubmitting}
                        >
                            Done
                        </Button>
                    </DialogActions>
                </Dialog>
            </div>
        </DashboardLayout>
    );
};

export default UploadAffiliateCollege;